/**
 * @copyright 2020 @ DigiNet
 * @author rocachien
 * @create 2020/02/27 18:12
 * @update 2020/02/27 18:12
 */

module.exports = {
    api: process && process.env && process.env.REACT_APP_API ? process.env.REACT_APP_API : 'https://apricot.diginet.com.vn/api',
    url: process && process.env && process.env.REACT_APP_WEB ? process.env.REACT_APP_WEB : 'http://localhost:3035',
    secret : process && process.env && process.env.REACT_APP_SECRET ? process.env.REACT_APP_SECRET :  'd9hc5d0k5LnJx9Cvq3NwOe3uGy0cW9ja2kv3dg',
    system : process && process.env && process.env.REACT_APP_SYSTEM_URL ? process.env.REACT_APP_SYSTEM_URL : '',

    cdn: process && process.env && process.env.REACT_APP_CDN_URL ? process.env.REACT_APP_CDN_URL : 'https://apricot.diginet.com.vn/cdn-dev',
    secretCDN : process && process.env && process.env.REACT_APP_CDN_SECRET ? process.env.REACT_APP_CDN_SECRET :  'd3hc5d0k5LnJx9Cvq3NwOe3uGy0cW9ja2kv3dg',

    prefixLang : process && process.env && process.env.REACT_APP_PREFIXLANG ? process.env.REACT_APP_PREFIXLANG :  'CRM_',
    companyCode : process && process.env && process.env.REACT_APP_COMPANYCODE ? process.env.REACT_APP_COMPANYCODE :  'APRICOT',
    productID : process && process.env && process.env.REACT_APP_PRODUCTID ? process.env.REACT_APP_PRODUCTID :  'WCRM',

    mookAPI: process && process.env && process.env.REACT_APP_MOOK_API ? process.env.REACT_APP_MOOK_API :  'NO',
    keyEnv: process && process.env && process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV :  'NO',
};

